import axios from 'axios';
import Http from '../utils/Http';
import Urls from "./Urls";

const CustomerService = {
    fetchData: async (url, auth, customerId) => {
        if (!auth || !customerId) {
            return null;
        }
        const formattedUrl = url.replace('{customerId}', customerId);
        try {
            const response = await axios.get(formattedUrl, {
                params: Http.getRequiredParams(auth.data.current)
            });
            return response.data;
        } catch (e) {
            console.error(e);
            return e.response.data;
        }
    },
    
    getCustomerById: async function(auth, customerId) {
        return await this.fetchData(Urls.CUSTOMER_BY_ID, auth, customerId);
    },
    
    getPurchasedServices: async function(auth, customerId) {
        return await this.fetchData(Urls.PURCHASED_SERVICES, auth, customerId);
    }
};

export default CustomerService;